<!--
 * @Author: lidan
 * @Date: 2021-01-21 13:58:49
 * @LastEditTime: 2021-02-01 17:40:48
 * @LastEditors: lidan
 * @Description: 运输线路
 * @FilePath: \e6-module-order-waybill-process\src\e6-module-order-waybill-process\views\temporaryDispatch\components\transportRoutes.vue
-->
<template>
  <div class="transport-routes">
    <!-- 折叠(节点数大于2) -->
    <div v-if="isFold" class="transport-routes-content">
      <!-- 起始节点 -->
      <section class="routes-node">
        <routes-node :node="lineList[0]" />
      </section>
      <!-- 展开N个运输节点 -->
      <section class="routes-node">
        <el-button type="text" class="handle-fold" @click="isFold = false">
          展开{{ lineList.length - 2 }}个运输节点
        </el-button>
      </section>
      <!-- 结束节点 -->
      <section class="routes-node">
        <routes-node :node="lineList[lineList.length - 1]" />
      </section>
    </div>

    <!-- 展开(节点数大于2或点击展开N个运输节点) -->
    <div v-else class="transport-routes-content">
      <section
        class="routes-node"
        v-for="(item, index) in lineList"
        :key="item + index"
      >
        <routes-node :node="item" />
      </section>
    </div>
  </div>
</template>

<script>
// components
const routesNode = {
  props: {
    node: Object
  },
  template: `
      <section class="routes-node">
        <div v-if="node.nodeType !== 3" class="status">
          <span :class="\`font-icon status-\${node.nodeType}\`">
            {{ node.nodeTypeStr }}
          </span>
        </div>
        <div v-else class="status">
          <span class="font-icon status-1">装</span>
          <span class="font-icon status-2">卸</span>
        </div>
        <span class="node-name">{{ node.customAreaName }}</span>
        <span class="node-address">（{{ node.customAreaAddress  }}）</span>
      </section>
  `
};

export default {
  props: ["lineList"],
  components: { routesNode },

  data() {
    return {
      isFold: false
    };
  },
  watch: {
    "lineList.length": {
      handler(val) {
        this.isFold = val > 2;
      },
      immediate: true
    }
  }
};
</script>

<style lang="scss" scoped>
.transport-routes {
  min-height: 86px;
  max-height: 150px;
  overflow: auto;
  width: 696px;
  //每个节点
  /deep/ {
    .routes-node {
      position: relative;
      margin-bottom: 15px;
      &:nth-last-child(1) {
        margin-bottom: 0;
      }
    }
    .node-name {
      color: #48494c;
    }
    .node-address {
      color: #898c91;
    }
    //节点运输状态
    .status {
      display: inline-block;
      //“装”“卸”等字体图标
      .font-icon {
        display: inline-block;
        font-size: 12px;
        border-radius: 4px;
        width: 18px;
        height: 18px;
        line-height: 18px;
        text-align: center;
        color: #fff;
        margin-right: 5px;
      }
      .status-1 {
        background-color: #46a1fd;
      }
      .status-2 {
        background-color: #a877e5;
      }
      .status-4 {
        background-color: #00bebc;
      }
      .status-5 {
        background-color: #78c950;
      }
      .status-6 {
        background-color: #33bb63;
      }
    }

    .handle-fold {
      margin-left: 23px;
    }
  }
}
.transport-routes-content {
  position: relative;
}
.transport-routes-content::before {
  position: absolute;
  top: 0;
  left: 9px;
  content: "";
  display: block;
  height: 100%;
  width: 1px;
  background-color: #e4e7ed;
}

/deep/.el-button--mini {
  padding: 0;
}
</style>
